import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';
import type { Address } from '../../../contracts';
import type { RootState } from '../../../store/types';
import PageTitle from '../../../shared/components/PageTitle';
import { TabContent } from '../../../routes/RouterOutlet.styles';
import EditAddressForm from '../EditAddressForm/EditAddressForm';
import { personalDetailsSelectors } from '../ducks';
import { getDisplayNameByPath } from '../../../utilities';
import LoadingPage from '../../../shared/components/LoadingPage';
import ErrorPage from '../../../shared/components/ErrorPage';
import EditDisclaimer from '../../../shared/components/EditDisclaimer';
import EditOrderModal from '../../../shared/components/Modals/EditOrderModal';

type OwnProps = {
  location?: { pathname: string };
};

type StateProps = {
  address: Address | null;
  isLoadingPersonalDetails: boolean;
  isOrderPlaced: boolean;
  personalDetailsError: Record<string, unknown>;
  sectionName: string;
};

const EditHomeAddress = ({
  address,
  sectionName,
  isLoadingPersonalDetails,
  personalDetailsError,
  isOrderPlaced
}: OwnProps & StateProps) => {
  if (!address) return null;
  const hasError = !isEqual(personalDetailsError, {});
  const shouldShowError = !isLoadingPersonalDetails && hasError;
  const shouldShowComponent = !isLoadingPersonalDetails && !hasError;

  return (
    <>
      <PageTitle title="Edit Home Address" />
      {isOrderPlaced && <EditDisclaimer />}
      {isOrderPlaced && <EditOrderModal />}
      {isLoadingPersonalDetails && <LoadingPage />}
      {shouldShowError && <ErrorPage />}

      {shouldShowComponent && (
        <TabContent>
          <EditAddressForm requestKind="HomeOnly" address={address} sectionName={sectionName} />
        </TabContent>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
  sectionName: getDisplayNameByPath(ownProps?.location?.pathname ?? ''),
  address: personalDetailsSelectors.getHomeAddress(state),
  isLoadingPersonalDetails: personalDetailsSelectors.getIsLoadingPersonalDetails(state),
  personalDetailsError: personalDetailsSelectors.getPersonalDetailsError(state),
  isOrderPlaced: personalDetailsSelectors.getIsOrderPlaced(state)
});

export default connect(mapStateToProps)(EditHomeAddress);
